function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -0.25em 0 0 -0.125em;\n  color: grey;\n  opacity: 0.3;\n  animation: ", " 2s linear infinite;\n\n  &:nth-child(2) {\n    width: 0.5em;\n    height: 0.25em;\n    margin: -1.75em 0 0 -1.875em;\n    transform: translate(2.5em, 2.25em);\n    opacity: 0.2;\n    animation: ", " 1.5s linear infinite;\n  }\n  &:before,\n  &:after {\n    content: '';\n    position: absolute;\n    z-index: 2;\n    top: 50%;\n    left: 50%;\n    margin: -1.625em 0 0 -1.0125em;\n    border-top: 1.25em solid transparent;\n    border-right: 0.75em solid;\n    border-bottom: 0.75em solid;\n    border-left: 0.5em solid transparent;\n    transform: skewX(-10deg);\n  }\n  &:after {\n    margin: -0.25em 0 0 -0.25em;\n    border-top: 0.75em solid;\n    border-right: 0.5em solid transparent;\n    border-bottom: 1.25em solid transparent;\n    border-left: 0.75em solid;\n    transform: skewX(-10deg);\n  }\n  &:nth-child(2):before {\n    margin: -0.75em 0 0 -0.5em;\n    border-top: 0.625em solid transparent;\n    border-right: 0.375em solid;\n    border-bottom: 0.375em solid;\n    border-left: 0.25em solid transparent;\n  }\n  &:nth-child(2):after {\n    margin: -0.125em 0 0 -0.125em;\n    border-top: 0.375em solid;\n    border-right: 0.25em solid transparent;\n    border-bottom: 0.625em solid transparent;\n    border-left: 0.375em solid;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n45% {\n  color: #fff;\n  background: #fff;\n  opacity: 0.2;\n}\n50% {\n  color: ", ";\n  background: ", ";\n  opacity: 1;\n}\n55% {\n  color: #fff;\n  background: #fff;\n  opacity: 0.2;\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled, { keyframes } from 'styled-components';
import { ThemePropType, defaultTheme } from '../constants';

var BoltAnimation = function BoltAnimation(_ref) {
  var theme = _ref.theme;
  return keyframes(_templateObject(), theme.boltColor, theme.boltColor);
};

var Bolt = styled.div.attrs({
  'data-e2e': 'bolt',
  'data-animation': true
})(_templateObject2(), BoltAnimation, BoltAnimation);
Bolt.propTypes = {
  theme: ThemePropType
};
Bolt.defaultProps = {
  theme: defaultTheme
};
Bolt.displayName = 'Bolt';
export default Bolt;